import { callApi } from '@local_modules/generic/fetch.js'

//
export async function loadChartOfAccountsWithStats (appAccountId) {
  const apiUrl = '/api/xero-accounting/by-account/:appAccountId/chart-of-accounts?withStats=true'

  const data = await callApi(apiUrl, {
    appAccountId,
    withStats: true
  })
  console.log('loadChartOfAccountsWithStats', data)

  return data
}
